import { ExternalLink } from "lucide-react";
import { SOURCES } from "@/lib/legal";

export const SourcesTable = ({ light = false, testid = "sources-table" }) => (
  <div className={`overflow-x-auto rounded-2xl border ${light ? "border-slate-200 bg-white" : "border-[#1b3d30]"}`} data-testid={testid}>
    <table className="w-full text-sm min-w-[640px]">
      <thead className={light ? "bg-[#00f2a1]/10 text-[#007a50]" : "bg-[#0f2c22] text-[#00f2a1]"}>
        <tr className="text-left text-xs uppercase tracking-wide">
          <th className="px-4 py-3 font-semibold">Normativa / Requisito</th>
          <th className="px-4 py-3 font-semibold">Organismo Emisor</th>
          <th className="px-4 py-3 font-semibold">Sitio Web Oficial</th>
        </tr>
      </thead>
      <tbody>
        {SOURCES.map((s) => (
          <tr key={s.sitio} className={`border-t ${light ? "border-slate-100 text-slate-700" : "border-[#1b3d30] text-slate-300"}`}>
            <td className="px-4 py-3">{s.norma}</td>
            <td className="px-4 py-3">{s.organismo}</td>
            <td className="px-4 py-3 whitespace-nowrap">
              <a href={`https://${s.sitio}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[#00b37a] hover:text-[#00f2a1] hover:underline">{s.sitio}<ExternalLink className="w-3.5 h-3.5" /></a>
              {s.nota && <span className="block text-[11px] opacity-70">{s.nota}</span>}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
